import { z } from 'zod';

export const DeactivateNetworkResponseSchema = z.object({
  networkId: z.uuid(),
  active: z.literal(false),
});

export type DeactivateNetworkResponse = z.infer<typeof DeactivateNetworkResponseSchema>;
